import type { ListMeasurementsParams, Network } from '@amarantos/api-client'

import { WHOLE_LIST_PER_PAGE } from '@/utils/whole-list'

export function toListNetworkMeasurementsParams(networkId: Network['id']): ListMeasurementsParams {
	return { network_id: networkId, page: 1, per_page: WHOLE_LIST_PER_PAGE }
}
